const conf = {
  online_host: 'http://front:8540',
  touch_host: 'http://touch.in.taou.com',
  // touch_host: 'http://10.11.80.143:8080',
  // online_host: 'http://10.11.1.151:8080',
  rpc_host: 'http://rpc:8540',
  groundhog_prefix: '/sdk/platform/groundhog',
  sdk_host: 'https://maimai.cn',
  node_host: 'https://maimai.cn',
  ep_host: 'http://ep-mdg.in.taou.com',
  auth_host: 'http://auth.in.taou.com',
  local_host: 'http://127.0.0.1:3000',
  open_host: 'https://open.taou.com',
  dorami_host: 'http://dorami:8530',
};

export default conf;
